module.exports = __webpack_public_path__ + "img/castlevania.0b263989.png";